declare const initCookieConsent: () => any;
declare const cookieConsentTexts: object;
declare const cookieConsentCookieName: string;

export interface CookiePreferencesCookie
{
    level?: string[]
    revision?: number,
    data?: any,
    rfc_cookie?: boolean
}

export default class CookieConsent {
    private cc: any;
    private callBack: (acceptedCategories: string[]) => void;

    constructor(callBack: (acceptedCategories: string[]) => void) {
        this.callBack = callBack;
    }

    public init(): void {
        if (typeof initCookieConsent === "undefined") {
            // skip if cookie consent is not enabled
            return;
        }

        this.cc = initCookieConsent();

        const that = this;

// run plugin with config object
        this.cc.run({
            current_lang: "already-localised",
            autoclear_cookies: true,                   // default: false
            // theme_css: "",
            cookie_name: cookieConsentCookieName,             // default: "cc_cookie"
            cookie_expiration: 365,                    // default: 182
            // page_scripts: false,
            // auto_language: null,                     // default: null; could also be "browser" or "document"
            // autorun: true,                           // default: true
            // delay: 0,                                // default: 0
            force_consent: true,
            // hide_from_bots: false,                   // default: false
            // remove_cookie_tables: false              // default: false
            // cookie_domain: location.hostname,        // default: current domain
            // cookie_path: "/",                        // default: root
            // cookie_same_site: "Lax",
            use_rfc_cookie: true,                   // default: false
            // revision: 0,                             // default: 0

            gui_options: {
                consent_modal: {
                    layout: "bar",                      // box,cloud,bar
                    position: "bottom center",           // bottom,middle,top + left,right,center
                    transition: "slide",                 // zoom,slide
                },
                settings_modal: {
                    layout: "box",                      // box,bar
                    // position: "left",                // right,left (available only if bar layout selected)
                    transition: "slide",                 // zoom,slide
                },
            },

            onAccept(cookieParam: any): void {
                // it's possible to i.e. send request to server here
            },

            onChange(cookiePar: any, changedPreferences: string[]): void {
                // it's possible to react to preference change here, by doing for example
                if (changedPreferences.indexOf("preferential") > -1) {
                    that.callBack(changedPreferences);

                    // if (!this.cc.allowedCategory("preferential")) {
                    // }
                }
            },

            onFirstAction(userPreferences: any, cookie: any): void {
                that.callBack(userPreferences.accepted_categories);
            },

            languages: cookieConsentTexts,
        });
    }

    /***
     * Sends request to the portal.
     * This sets or unsets the language cookie and returns main page layout used to update language dropdown.
     * @private
     */
}
